import React from 'react'
import { Typography } from '@material-ui/core'
import { CampaignType } from '../../../../constants/marketingCampaign'
import { CampaignDefinition } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { Menu } from '../../MarketingCampaigns.promo.services'
import { BNGM_SCOPE, BNGM_TARGET_TYPE, BuyNGetMRuleState } from './types'
import { validateBuyNGetMRule } from './validate'
import { buildBuyNGetMFormValues } from './buildFormValues'
import { BuyNGetMRuleStep } from './RuleStep.view'
import { BuyNGetMConfirmationSummary } from './ConfirmationSummary.view'

const ruleDescription = (
	<Typography variant="body2" style={{ color: '#616161', marginBottom: 14, lineHeight: 1.65 }}>
		Définissez le nombre total de produits à ajouter au panier pour débloquer une remise sur
		d&apos;autres produits du panier. Les produits les moins chers seront automatiquement
		remisés.
	</Typography>
)

function getInitialRuleFromCampaign(
	campaign: any,
	_menus: Menu,
): BuyNGetMRuleState {
	const config = campaign.config || {}
	const targetType = config.target

	const scopeType =
		targetType === BNGM_TARGET_TYPE.OPTION_LIST
			? BNGM_SCOPE.OPTIONS
			: BNGM_SCOPE.PRODUCTS

	const products =
		scopeType === BNGM_SCOPE.PRODUCTS && Array.isArray(config.products)
			? config.products.map((p: any) => ({
						productKey: p.productKey,
						productSectionKey: p.productSectionKey,
					}))
			: []

	const selectedProductKeys = products.map((p: { productKey: string }) => p.productKey)

	const selectedOptionListKey =
		scopeType === BNGM_SCOPE.OPTIONS && config.optionListKey
			? String(config.optionListKey)
			: null

	return {
		scopeType,
		products,
		selectedProductKeys,
		selectedOptionListKey,
		numProductsPaid: config.numProductsPaid ?? 2,
		numProductsDiscounted: config.numProductsDiscounted ?? 1,
		discountPercent: config.discount?.value ?? 100,
	}
}

export const buyNGetMCheapestAtDiscountDefinition: CampaignDefinition<BuyNGetMRuleState> = {
	type: CampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT,
	RuleStep: BuyNGetMRuleStep,
	ConfirmationSummary: BuyNGetMConfirmationSummary,
	defaultRule: {
		scopeType: BNGM_SCOPE.PRODUCTS,
		products: [],
		selectedProductKeys: [],
		selectedOptionListKey: null,
		numProductsPaid: 2,
		numProductsDiscounted: 1,
		discountPercent: 100,
	},
	validateRule: validateBuyNGetMRule,
	buildFormValues: buildBuyNGetMFormValues,
	ruleDescription,
	getInitialRuleFromCampaign,
	confirmationLimitPolicy: 'optional',
	showOrderTypesInConfirmation: true,
	forceDeliveryOrderType: false,
	allowsPermanent: true,
	supportsCampaignNaming: true,
}
